module.exports = __webpack_public_path__ + "static/img/Arystote.ca9b66e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Arystote.png
// module id = W2cA
// module chunks = 1